<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
import dayjs from "dayjs";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "revenue",
      key: "id",
      kv: "",
      selectC: "",
      url: {},
      items: [
        { label: "新增当月收入", type: "header" },
        {
          label: "医院名称",
          name: "customerId",
          value: "",
          type: "selectDesk",
          width: "400px",
          dropList: [],
          rules: [
            {
              required: true,
              message: "医院不能为空",
            },
          ],
          selected: 0,
          onChange: this.onChangecustomer,
        },
        {
          label: "项目名称",
          name: "projectId",
          value: "",
          type: "selectDesk",
          width: "400px",
          dropList: [],
          selected: 0,
          onChange: this.onChangeproject,
        },
        {
          label: "收入日期",
          KeyEnter: this.search,
          name: "monthTime",
          value: dayjs().format("YYYY-MM"),
          width: "400px",
          type: "month",
          rules: [{ required: true }],
        },
        {
          label: "计费模式",
          name: "payType",
          type: "select",
          width: "400px",
          value: 1,
          rules: [{ required: true }],
          dropList: [
            {
              value: 1,
              name: "全包",
            },
            {
              value: 2,
              name: "按台收费",
            },
            {
              value: 3,
              name: "自定义收费",
            },
          ],
          onChange: this.onisParent,
        },
        {
          label: "合同总金额",
          name: "contractMoney",
          value: 0,
          type: "number",
          width: "400px",
          formatter: (value) => `¥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          parser: (value) => value.replace(/\¥\s?|(,*)/g, ""),
        },
        {
          label: "月收入",
          name: "monthRevenue",
          value: 0,
          type: "number",
          width: "400px",
          min: 0,
          rules: [{ required: true }],
          formatter: (value) => `¥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          parser: (value) => value.replace(/\¥\s?|(,*)/g, ""),
        },
      ],
      forms: {
        contractMoney: 0,
      },
    };
  },
  created() {
    let query = this.$route.query;
    this.loadAdminUserData();
    if (query.action === "edit") {
      this.kv = query.kv;
      this.initData();
    }
  },
  mounted() {},
  methods: {
    async onChangeproject(id) {
      let q = {};
      if (id) {
        let res = await $utils.api.load(`/admin/system/management/get/${id}`, q);
        if (res && res.data) {
          let num = res.data.contractMoney ? res.data.contractMoney : 0;
          this.forms.contractMoney = num;
          this.items[this.getItemIndex("contractMoney")].value = num;
        }
      }
    },
    async onChangecustomer(customerId) {
      let oldprojectId;
      if (this.forms.projectId) {
        oldprojectId = this.forms.projectId;
      }
      let q = {};
      let res = await $utils.api.load(
        `/admin/system/management/parentCustomerList/${customerId}`,
        q
      );
      if (res && res.data) {
        let ll = res.data;
        if (ll && oldprojectId && this.action == "add") {
          this.forms.projectId = null;
          this.forms.contractMoney = 0;
          this.items[this.getItemIndex("projectId")].value = "";
          this.items[this.getItemIndex("contractMoney")].value = "";
        }
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          if (oldprojectId != element.id && this.action == "add") {
            this.forms.projectId = null;
            this.forms.contractMoney = 0;
            this.items[this.getItemIndex("projectId")].value = "";
            this.items[this.getItemIndex("contractMoney")].value = "";
          }
          let xx = {};
          xx.value = element.id;
          xx.name = element.name;
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "projectId") {
            this.items[index]["dropList"] = dropList;
          }
        }
      }
    },
    initData() {
      // 加载详情数据
      let id = this.kv;
      $utils.api.load(`/admin/system/revenue/${id}`, {}).then((res) => {
        if (res && res.data) {
          this.forms = res.data;
          this.onChangecustomer(res.data.customerId);
          this.onisParent(res.data.payType);
        }
      });
    },
    onisParent(val) {
      if (val == 2) {
        this.items[this.getItemIndex("monthRevenue")].type = "kong";
        this.items[this.getItemIndex("monthRevenue")].value = "";
      } else {
        this.items[this.getItemIndex("monthRevenue")].type = "number";
      }
    },
    async handleSubmit() {
      if (!this.action) {
        return true;
      }
      let q = this.forms;
      await this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(`/admin/system/revenue`, q, this.action == "edit" ? "PUT" : "POST")
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                $utils.url.go(-1);
              }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        }
      });
    },
    async loadAdminUserData() {
      let q = {};
      let res = await $utils.api.load("/admin/system/customer/list", q);
      if (res && res.rows) {
        let ll = res.rows;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.id;
          xx.name = element.customerName;
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "customerId") {
            this.items[index]["dropList"] = dropList;
          }
        }
      }
    },
  },
};
</script>
